import { render, staticRenderFns } from "./RolePrivilegesInfoModal.vue?vue&type=template&id=29f09c34&scoped=true&"
import script from "./RolePrivilegesInfoModal.vue?vue&type=script&lang=js&"
export * from "./RolePrivilegesInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./RolePrivilegesInfoModal.vue?vue&type=style&index=0&id=29f09c34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f09c34",
  null
  
)

export default component.exports